import { AppState } from '../../types';
import { ArticleCommentState } from './reducers/current';
import { ArticleCommentListState } from './reducers/list';

export const selectArticleComments = (state: AppState): ArticleCommentListState => state.articleComments.list;

export const selectArticleComment = (state: AppState): ArticleCommentState => state.articleComments.current;
